import { API_FUNDING_ADMIN_STATUS_SUMMARY } from "services/endpoints";

export default (build) =>
	build.query({
		query: () => ({
			url: API_FUNDING_ADMIN_STATUS_SUMMARY,
			method: "GET"
		})
	});
